export class DeplacerGroupDossier
{
    taskIdList:String[];
}